'use client'

import useSearchStore from '@app/components/search-section/store/search-store'
import Backdrop from './backdrop'
import triggerAnalytics from '@gamezop/analytics-sdk/client/trigger-analytics'

const SearchBackdrop = () => {
  const {isFocused, setFocused, setSearchQuery} = useSearchStore()
  const handleClick = () => {
    setFocused(false)
    setSearchQuery('')
    triggerAnalytics('search-btn-closed').sendAll()
  }
  return <Backdrop showBackdrop={isFocused} onClick={handleClick} className='!z-0' />
}

export default SearchBackdrop
